import pick from 'lodash.pick';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export enum ImageSource {
  upload = 'upload',
  canva = 'canva',
}

type OpenArgs = {
  source?: ImageSource;
  sourceState?: string;
  accept?: string;
  onSelect: (file: File) => void;
};

type State = Partial<OpenArgs> & {
  isOpen: boolean;
  open: (args: OpenArgs) => void;
  close: () => void;
  setSource: (args: Pick<OpenArgs, 'source' | 'sourceState'>) => void;
};

const useImagePickerStore = createWithEqualityFn<State>()(
  (set) => ({
    isOpen: false,
    source: undefined,
    sourceState: undefined,
    onSelect: undefined,
    open: (args) =>
      set({
        ...args,
        isOpen: true,
      }),
    close: () =>
      set({
        isOpen: false,
        source: undefined,
        sourceState: undefined,
        accept: undefined,
        onSelect: undefined,
      }),
    setSource: (state) => set(state),
  }),
  shallow
);

export const useImagePickerInternals = () => {
  return useImagePickerStore();
};

export const useImagePicker = () => {
  return useImagePickerStore((state) =>
    pick(state, ['open', 'close', 'setSource'])
  );
};
